module.exports = __webpack_public_path__ + "static/media/20.76afd0db.jpg";